module.exports = __webpack_public_path__ + "img/swiper-2.60442ca0.png";